import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SubscriberAddChild from "./SubscriberAddChild";

const SubscriberAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SubscriberAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default SubscriberAdd;
